import { useNavigate } from 'react-router';
import { TokenService } from "./TokenService";

export const AuthorizationService = {
    IsAdmin: function (user) {
        if (user == null || user.username == null) {
            return false;
        }

        const groups = TokenService.getUserGroups();

        return parseInt(groups.indexOf(process.env.REACT_APP_ADMIN_GROUP_ID)) > -1;
    },

    IsSubmitter: function (user) {
        if (user == null || user.username == null) {
            return false;
        }

        const groups = TokenService.getUserGroups();

        if (
            parseInt(groups.indexOf(process.env.REACT_APP_ADMIN_GROUP_ID)) > -1 ||
            parseInt(groups.indexOf(process.env.REACT_APP_SUBMITTER_GROUP_ID)) > -1
        ) {
            return true;
        }

        return false;
    },

    IsViewer: function (user) {
        if (user == null || user.username == null) {
            return false;
        }

        const groups = TokenService.getUserGroups();

        if (
            parseInt(groups.indexOf(process.env.REACT_APP_ADMIN_GROUP_ID)) > -1 ||
            parseInt(groups.indexOf(process.env.REACT_APP_SUBMITTER_GROUP_ID)) > -1 ||
            parseInt(groups.indexOf(process.env.REACT_APP_VIEWER_GROUP_ID)) > -1
        ) {
            return true;
        }

        return false;
    },

    RenderIfAdmin: function ({ children }) {
        var navigate = useNavigate();

        const user = TokenService.getUser();
        if (user == null || user.account.username == null) {
            return navigate("/", { replace: true });
        }

        const groups = TokenService.getUserGroups();

        if (
            parseInt(groups.indexOf(process.env.REACT_APP_ADMIN_GROUP_ID)) > -1
        ) {
            return <>{children}</>;
        } else {
            return navigate("/");
        }
    },

    RenderIfSubmitter: function ({ children }) {
        const navigate = useNavigate();

        const user = TokenService.getUser();
        if (user == null || user.account.username == null)
            return navigate("/", { replace: true });

        const groups = TokenService.getUserGroups();

        if (
            parseInt(groups.indexOf(process.env.REACT_APP_ADMIN_GROUP_ID)) > -1 ||
            parseInt(groups.indexOf(process.env.REACT_APP_SUBMITTER_GROUP_ID)) > -1
        ) {
            return <>{children}</>;
        } else {
            return navigate("/");
        }
    },

    RenderIfViewer: function ({ children }) {
        const navigate = useNavigate();

        const user = TokenService.getUser();
        if (user == null || user.account.username == null)
            return navigate("/");

        const groups = TokenService.getUserGroups();

        if (
            parseInt(groups.indexOf(process.env.REACT_APP_ADMIN_GROUP_ID)) > -1 ||
            parseInt(groups.indexOf(process.env.REACT_APP_SUBMITTER_GROUP_ID)) > -1 ||
            parseInt(groups.indexOf(process.env.REACT_APP_VIEWER_GROUP_ID)) > -1
        ) {
            return <>{children}</>;
        } else {
            return navigate("/");
        }
    },

};